module.exports = __webpack_public_path__ + "static/media/Luis.dc8fa975.JPG";